var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalDot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 4,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.544.477L.377 1.644a1.286 1.286 0 101.82 1.82l1.167-1.168a1.286 1.286 0 10-1.82-1.82z",
    fill: "#000"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNCIgaGVpZ2h0PSI0IiB2aWV3Qm94PSIwIDAgNCA0IiBmaWxsPSIjZmZmZmZmIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMS41NDM5NCAwLjQ3NjY5NEwwLjM3NzA4NCAxLjY0MzU2Qy0wLjEyNTY5NSAyLjE0NjM0IC0wLjEyNTY5NSAyLjk2MTQyIDAuMzc3MDg0IDMuNDYzMzRDMC44Nzk4NjQgMy45NjUyNyAxLjY5NDk1IDMuOTY2MTIgMi4xOTY4NyAzLjQ2MzM0TDMuMzYzNzMgMi4yOTY0OEMzLjg2NjUxIDEuNzkzNyAzLjg2NjUxIDAuOTc4NjE1IDMuMzYzNzMgMC40NzY2OTRDMi44NjA5NSAtMC4wMjYwODU0IDIuMDQ1ODYgLTAuMDI2MDg1NCAxLjU0Mzk0IDAuNDc2Njk0WiIgZmlsbD0iI2ZmZmZmZiIgLz4KPC9zdmc+Cg==";
export { SvgExternalDot as ReactComponent };